export const assumptionType = {
  MOT: "mot",
  PREVIOUSOWNERS: "previous owners"
};

export const errorMessages = {
  NETWORKERROR: "Network Error"
};

export const validationMessages = {
  SCALE: "Select an option on the scale to continue",
  STANDARD: "Please choose an option"
};
